import React from 'react';
import { Modal, Button } from 'antd';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { styles, createModalTitle } from '../ReconnectionModal.styles';

const HardReconnectionModal = ({ visible, onReconnect }) => {
  return (
    <Modal
      title={createModalTitle('Reconnection Failed')}
      open={visible}
      closable={false}
      centered
      footer={
        <div style={styles.modalFooter}>
          <Button
            key="refresh"
            type="primary"
            size="large"
            onClick={onReconnect}
            icon={
              <RefreshCw
                size={16}
                style={{ marginRight: '8px' }}
              />
            }
          >
            Reconnect
          </Button>
        </div>
      }
    >
      <div style={styles.modalContent}>
        <div style={styles.iconContainer}>
          <AlertTriangle
            size={48}
            style={{ color: '#666' }}
          />
        </div>
        <p style={styles.description}>
          We were unable to restore your internet connection automatically.
        </p>
        <p style={styles.instruction}>Click "Reconnect" to refresh the page and try again.</p>
      </div>
    </Modal>
  );
};

export default HardReconnectionModal;
